import {Box, Button} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import React from 'react'

import {RolePlantLookupChip} from '../../../components/Role/deprecated/RolePlantLookupChip'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'

const useStyles = makeStyles(() => ({
  deleteButton: {
    minWidth: 'auto'
  },
  container: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#7F9BA6',
    borderRadius: '3px',
    marginTop: '5px',
    padding: '6px 6px 6px 8px',
    marginBottom: '-1px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}))

interface Props {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeletePlant?(plantId: string): void
}

export const Plants: React.FC<Props> = ({groupedRoleAssignment, isEditing, handleDeletePlant}) => {
  const classes = useStyles()

  const {plantIds} = groupedRoleAssignment.variantDataScopes
  const {countryId} = groupedRoleAssignment.commonDataScopes

  if (!plantIds || plantIds.length === 0) {
    return null
  }

  return (
    <Box>
      <Box>
        {plantIds?.map((plantId) => (
          <Box key={plantId} className={classes.container}>
            <RolePlantLookupChip key={plantId} plantId={plantId} countryId={countryId as string} />
            {isEditing && (
              <Button
                variant="text"
                color="secondary"
                className={classes.deleteButton}
                onClick={() => {
                  handleDeletePlant?.(plantId)
                }}
              >
                <DeleteIcon />
              </Button>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
